export const AUTH_STORE_KEY = 'auth';
export const USER_STORAGE_KEY = 'user';
